<mat-form-field appearance="outline" class="text-area h-100 w-100">
  <mat-label class="proposal-header">Communication Address</mat-label>
  <textarea
    matInput
    placeholder="Enter your address As per your AAdhar"
    formControlName="owner_communication_addres"
    id-automation="owner_communication_address"
    minlength="{{ minLength }}"
    appRemoveNewlines
    appNoSpace
  ></textarea>

  <mat-error
    *ngIf="form.controls['owner_communication_addres']?.hasError('required')"
  >
    This is a required field.
  </mat-error>
  <mat-error
    [hidden]="isNotMinErrorMsg"
    *ngIf="form.controls['owner_communication_addres']?.hasError('minlength')"
  >
    Cannot be less than {{ minLength }} Characters
  </mat-error>
  <mat-error
    [hidden]="isNotShowErrorMsg"
    *ngIf="form.controls['owner_communication_addres']?.hasError('maxlength')"
  >
    Cannot be more than {{ maxLength }} Characters
  </mat-error>
</mat-form-field>
<div
  *ngIf="isNotShowErrorMsg"
  class="text-danger error"
  [ngClass]="isNotShowErrorMsg ? 'mb-3 ms-3' : ''"
>
  Cannot be more than {{ maxLength }} Characters
</div>

<div
  *ngIf="isNotMinErrorMsg"
  class="text-danger error"
  [ngClass]="isNotShowErrorMsg ? 'mb-3 ms-3' : ''"
>
  Cannot be less than {{ minLength }} Characters
</div>
